<template>
    <div class="p-3">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h4 class="text-gray-800 font-weight-bold m-0">Historial de Asistencia</h4>
            <div class="text-muted small">
                <i class="fas fa-info-circle mr-1"></i> Mostrando registros recientes
            </div>
        </div>
        
        <div class="table-responsive rounded-lg shadow-sm border border-light">
            <table class="table table-hover mb-0 custom-table">
                <thead class="bg-light-gray">
                    <tr>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0 pl-4">Fecha</th>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0">Entrada</th>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0">Salida</th>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0">Estado</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(record, index) in history" :key="index">
                        <td class="align-middle pl-4 font-weight-bold text-dark">
                            {{ formatDate(record.date) }}
                        </td>
                        <td class="align-middle">
                            <span v-if="record.entry" class="badge badge-soft-success p-2">
                                <i class="far fa-clock mr-1"></i> {{ record.entry }}
                            </span>
                            <span v-else class="text-muted small italic">Sin registro</span>
                        </td>
                        <td class="align-middle">
                            <span v-if="record.exit" class="badge badge-soft-info p-2">
                                <i class="far fa-clock mr-1"></i> {{ record.exit }}
                            </span>
                            <span v-else class="text-muted small italic">Sin registro</span>
                        </td>
                        <td class="align-middle">
                            <span v-if="record.entry && record.exit" class="text-success small">
                                <i class="fas fa-check-circle mr-1"></i> Completo
                            </span>
                            <span v-else class="text-warning small font-italic">
                                <i class="fas fa-exclamation-triangle mr-1"></i> Incompleto
                            </span>
                        </td>
                    </tr>
                    <tr v-if="history.length === 0">
                        <td colspan="4" class="text-center py-5 text-muted">
                            <div class="d-flex flex-column align-items-center">
                                <i class="fas fa-calendar-times fa-3x mb-3 text-gray-300"></i>
                                <p class="m-0">No se encontraron registros de asistencia para este usuario.</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import request from '@/services/request';
import moment from 'moment';
// Localización de Moment.js para el historial de asistencia
import 'moment/locale/es';
moment.locale('es');

export default {
    name: 'AttendanceHistoryTab',
    props: ['userId'],
    data() {
        return {
            history: []
        };
    },
    watch: {
        userId: {
            immediate: true,
            handler(val) {
                if (val) this.fetchHistory();
            }
        }
    },
    methods: {
        async fetchHistory() {
            try {
                const { data } = await request.get(`/attendance/history/${this.userId}`);
                this.history = data;
            } catch (error) {
                console.error("Error fetching attendance history:", error);
            }
        },
        formatDate(date) {
            return moment(date).format('DD [de] MMMM, YYYY');
        }
    }
};
</script>

<style scoped>
.text-gray-800 { color: #1f2937; }
.text-gray-300 { color: #d1d5db; }
.bg-light-gray { background-color: #f9fafb; }
.text-xs { font-size: 0.75rem; }
.border-light { border-color: #e5e7eb !important; }

.custom-table th {
    letter-spacing: 0.05em;
    padding: 1rem 0.75rem;
}
.custom-table td {
    color: #4b5563;
    font-size: 0.9rem;
    padding: 1rem 0.75rem;
}

.badge-soft-success {
    background-color: #d1fae5;
    color: #065f46;
    border-radius: 8px;
    font-weight: 600;
}

.badge-soft-info {
    background-color: #e0f2fe;
    color: #075985;
    border-radius: 8px;
    font-weight: 600;
}

.italic { font-style: italic; }
</style>
